import "bootstrap";
import Vue from 'vue/dist/vue.js';
import FixedHeader from 'vue-fixed-header';
import VuePrlx from 'vue-prlx';
import Swiper from 'swiper/bundle';
import VueScrollTo from 'vue-scrollto';
import mapboxgl from '!mapbox-gl';

window.axios = require('axios');

Vue.use(VuePrlx);
Vue.use(VueScrollTo);
Vue.component('fixed-header', FixedHeader);
Vue.component('instagram-home', require('../vue/InstagramHome.vue').default);
Vue.component('example-component', require('../vue/ExampleCompoment.vue').default);

const app = new Vue({
    el: '#app',
    data: {
        menu_open: false
    }
});

mapboxgl.accessToken = 'pk.eyJ1IjoibGVwYXJpc2JyZXRhZ25lIiwiYSI6ImNreDBmNTgwNTByYWYyeG9ic2E4ZW04dDMifQ.pGBONyYi1KsUlEB3650Tzg';
const map = new mapboxgl.Map({
    container: 'map', // container ID
    style: 'mapbox://styles/leparisbretagne/ckx0fmziq26pq15nsg56m0zk0', // style URL
    center: [39.1102744,21.5784333], // starting position [lng, lat]
    zoom: 9 // starting zoom
});

var marker = new mapboxgl.Marker()
    .setLngLat([39.1102744,21.5784333])
    .addTo(map);

map.scrollZoom.disable();

const swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});